import { TabKey } from "./types";
import { ParseKeys } from "i18next";

// Slow fallback only — real-time delivery comes from the messageSent
// websocket subscription; these keep things moving if the socket is down.
export const CONVERSATIONS_POLL_MS = 60000;
export const MESSAGES_POLL_MS = 30000;

export const ATTACHMENT_FOLDER = "message-attachments";
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;
export const MAX_ATTACHMENTS_PER_MESSAGE = 10;
export const ACCEPTED_FILE_TYPES = "image/*,application/pdf";

export const MAX_MESSAGE_LENGTH = 5000;
export const MESSAGES_PAGE_SIZE = 50;

export const MESSAGE_TABS: { label: ParseKeys<"messages">; path: TabKey }[] = [
  { label: "tabs.all", path: "all" },
  { label: "tabs.starred", path: "starred" },
  { label: "tabs.unread", path: "unread" },
  { label: "tabs.archived", path: "archived" },
];
